import { takeLatest, put, call, fork } from "redux-saga/effects";
import {
    fetchedBusinessProgramList,
    failedFetchBusinessProgramList,
    fetchedBusinessProgramDetail,
    failedFetchBusinessProgramDetail,

    createdBusinessProgram,
    failedCreateBusinessProgram,

    createdBuyerQualificationDetails,
    failedCreateBuyerQualificationDetails,

    createdBusinessProgramInterest,
    failedCreateBusinessProgramInterest,

    createdBusinessProgramFee,
    failedCreateBusinessProgramFee,

    createdBusinessProgramFacilityDetails,
    failedCreateBusinessProgramFacilityDetails,

    createdBusinessProgramRecourseDetails,
    failedCreateBusinessProgramRecourseDetails,

    createdBusinessProgramCashBack,
    failedCreateBusinessProgramCashBack,

    createdBusinessAttachments,
    failedCreateBusinessAttachments,

    createdBasicDetails,
    failedCreateBasicDetails,

    createdBusinessAgreementDetails,
    failedCreateBusinessAgreementDetails,

    updatedBusinessProgram,
    failedUpdateBusinessProgram,

    updatedBuyerQualificationDetails,
    failedUpdateBuyerQualificationDetails,

    updatedBusinessProgramInterest,
    failedUpdateBusinessProgramInterest,

    updatedBusinessProgramFee,
    failedUpdateBusinessProgramFee,

    updatedBusinessProgramFacilityDetails,
    failedUpdateBusinessProgramFacilityDetails,

    updatedBusinessProgramRecourseDetails,
    failedUpdateBusinessProgramRecourseDetails,

    updatedBusinessProgramCashBack,
    failedUpdateBusinessProgramCashBack,

    updatedBusinessAttachments,
    failedUpdateBusinessAttachments,

    updatedBasicDetails,
    failedUpdateBasicDetails,

    updatedBusinessAgreementDetails,
    failedUpdateBusinessAgreementDetails,

    fetchedCompanyBusinessProgramDetail,
    failedFetchCompanyBusinessProgramDetail,

} from "./../actions";

import { message } from "antd";

import { SchemesService } from "services";

import { MPA_DPA_ACTIONS } from "constants/actions";

function* getBusinessProgramList() {
    const { data, error } = yield call(
        SchemesService.getBusinessProgramList
    );
    if(!error) {
        yield put(fetchedBusinessProgramList(data));
    } else {
        yield put(failedFetchBusinessProgramList(error));
    }
}

function* getBusinessProgramDetails({payload}) {
    const { data, error } = yield call(
        SchemesService.getBusinessProgram, payload.id
    );
    if(!error) {
        yield put(fetchedBusinessProgramDetail(payload.id, data));
    } else {
        yield put(failedFetchBusinessProgramDetail(error));
    }
}

function* getCompanyBusinessProgramDetails({payload}) {
    const { data, error } = yield call(
        SchemesService.getCompanyBusinessProgram, payload.id
    );
    if(!error) {
        yield put(fetchedCompanyBusinessProgramDetail(payload.id, data));
    } else {
        yield put(failedFetchCompanyBusinessProgramDetail(error));
    }
}

function* createBusinessProgram({payload}) {
    const { data, error } = yield call(SchemesService.createBusinessProgram, payload.data);
    if(!error) {
        yield put(createdBusinessProgram(payload.company_id, data.data));
        message.success("Business Program Created");
    } else {
        yield put(failedCreateBusinessProgram(error));
        message.error("Business Program Creation Failed");
    }
}

function* createBusinessProgramInterest({payload}) {
    const { data, error } = yield call(SchemesService.createBusinessProgramInterest, payload.data, payload.id);
    if(!error) {
        yield put(createdBusinessProgramInterest(data));
        message.success("Interest details Saved");
    } else {
        yield put(failedCreateBusinessProgramInterest(error));
        message.error("Interest details Create Failed");
    }
}

function* createBuyerQualificationDetails({payload}) {
    const { data, error } = yield call(SchemesService.createBuyerQualificationDetails, payload.data);
    if(!error) {
        yield put(createdBuyerQualificationDetails(data));
        message.success("Buyer Qualification details Saved");
    } else {
        yield put(failedCreateBuyerQualificationDetails(error));
        message.error("Buyer Qualification details Create Failed");
    }
}

function* createBusinessProgramFee({payload}) {
    const { data, error } = yield call(SchemesService.createBusinessProgramFee, payload.data);
    if(!error) {
        yield put(createdBusinessProgramFee(data));
        message.success("Fee details Saved");
    } else {
        yield put(failedCreateBusinessProgramFee(error));
        message.error("Fee details Create Failed");
    }
}

function* createBusinessProgramFacilityDetails({payload}) {
    const { data, error } = yield call(SchemesService.createBusinessProgramFacilityDetails, payload.data);
    if(!error) {
        yield put(createdBusinessProgramFacilityDetails(data));
        message.success("Facility details Saved");
    } else {
        yield put(failedCreateBusinessProgramFacilityDetails(error));
        message.error("Facility details Create Failed");
    }
}

function* createBusinessProgramRecourseDetails({payload}) {
    const { data, error } = yield call(SchemesService.createBusinessProgramRecourseDetails, payload.data);
    if(!error) {
        yield put(createdBusinessProgramRecourseDetails(data));
        message.success("Recourse details Saved");
    } else {
        yield put(failedCreateBusinessProgramRecourseDetails(error));
        message.error("Recourse details Create Failed");
    }
}

function* createBusinessProgramCashBack({payload}) {
    const { data, error } = yield call(SchemesService.createBusinessProgramCashBack, payload.data);
    if(!error) {
        yield put(createdBusinessProgramCashBack(data));
        message.success("Cashback details Saved");
    } else {
        yield put(failedCreateBusinessProgramCashBack(error));
        message.error("Cashback details Create Failed");
    }
}

function* createBusinessAttachments({payload}) {
    const { data, error } = yield call(SchemesService.createBusinessAttachments, payload.data);
    if(!error) {
        yield put(createdBusinessAttachments(data));
        message.success("Buyer Qualification details Create Failed");
    } else {
        yield put(failedCreateBusinessAttachments(error));
        message.success("Buyer Qualification details Create Failed");
    }
}

function* createBasicDetails({payload}) {
    const { data, error } = yield call(SchemesService.createBasicDetails, payload.data);
    if(!error) {
        yield put(createdBasicDetails(data));
        message.success("Buyer Qualification details Create Failed");
    } else {
        yield put(failedCreateBasicDetails(error));
        message.success("Buyer Qualification details Create Failed");
    }
}

function* createBusinessAgreementDetails({payload}) {
    const { data, error } = yield call(SchemesService.createBusinessAgreementDetails, payload.data);
    if(!error) {
        yield put(createdBusinessAgreementDetails(data));
        message.success("Agreement details Saved");
    } else {
        yield put(failedCreateBusinessAgreementDetails(error));
        message.error("Agreement details Create Failed");
    }
}


function* updateBusinessProgram({payload}) {
    const { data, error } = yield call(SchemesService.updateBusinessProgram, payload.id, payload.data);
    if(!error) {
        yield put(updatedBusinessProgram(data));
        message.success("Business Program Updated");
    } else {
        yield put(failedUpdateBusinessProgram(error));
        message.error("Business Program Updation failed");
    }
}

function* updateBusinessProgramInterest({payload}) {
    const { data, error } = yield call(SchemesService.updateBusinessProgramInterest, payload.data);
    if(!error) {
        yield put(updatedBusinessProgramInterest(data));
        message.success("Interest details Saved");
    } else {
        yield put(failedUpdateBusinessProgramInterest(error));
        message.error("Interest details Update Failed");
    }
}

function* updateBuyerQualificationDetails({payload}) {
    const { data, error } = yield call(SchemesService.updateBuyerQualificationDetails, payload.id, payload.data);
    if(!error) {
        yield put(updatedBuyerQualificationDetails(data));
        message.success("Buyer Qualification details Saved");
    } else {
        yield put(failedUpdateBuyerQualificationDetails(error));
        message.error("Buyer Qualification details Update Failed");
    }
}

function* updateBusinessProgramFee({payload}) {
    const { data, error } = yield call(SchemesService.updateBusinessProgramFee, payload.data);
    if(!error) {
        yield put(updatedBusinessProgramFee(data));
        message.success("Fee details Update Failed");
    } else {
        yield put(failedUpdateBusinessProgramFee(error));
        message.error("Fee details Update Failed");
    }
}

function* updateBusinessProgramFacilityDetails({payload}) {
    const { data, error } = yield call(SchemesService.updateBusinessProgramFacilityDetails, payload.data);
    if(!error) {
        yield put(updatedBusinessProgramFacilityDetails(data));
        message.success("Facility details Updated");
    } else {
        yield put(failedUpdateBusinessProgramFacilityDetails(error));
        message.error("Facility details Update Failed");
    }
}

function* updateBusinessProgramRecourseDetails({payload}) {
    const { data, error } = yield call(SchemesService.updateBusinessProgramRecourseDetails, payload.data);
    if(!error) {
        yield put(updatedBusinessProgramRecourseDetails(data));
        message.success("Recourse details Updated");
    } else {
        yield put(failedUpdateBusinessProgramRecourseDetails(error));
        message.error("Recourse details Update Failed");
    }
}

function* updateBusinessProgramCashBack({payload}) {
    const { data, error } = yield call(SchemesService.updateBusinessProgramCashBack, payload.data);
    if(!error) {
        yield put(updatedBusinessProgramCashBack(data));
        message.success("Cashback details Updated");
    } else {
        yield put(failedUpdateBusinessProgramCashBack(error));
        message.error("Cashback details Update Failed");
    }
}

function* updateBusinessAttachments({payload}) {
    const { data, error } = yield call(SchemesService.updateBusinessAttachments, payload.data);
    if(!error) {
        yield put(updatedBusinessAttachments(data));
        message.success("Attachment details Updated");
    } else {
        yield put(failedUpdateBusinessAttachments(error));
        message.error("Attachment details Update Failed");
    }
}

function* updateBasicDetails({payload}) {
    const { data, error } = yield call(SchemesService.updateBasicDetails, payload.data);
    if(!error) {
        yield put(updatedBasicDetails(data));
        message.success("Basic details Updated");
    } else {
        yield put(failedUpdateBasicDetails(error));
        message.error("Basic details Update Failed");
    }
}

function* updateBusinessAgreementDetails({payload}) {
    const { data, error } = yield call(SchemesService.updateBusinessAgreementDetails, payload.data);
    if(!error) {
        yield put(updatedBusinessAgreementDetails(data));
        message.success("Agreement details Updated");
    } else {
        yield put(failedUpdateBusinessAgreementDetails(error));
        message.error("Agreement details Update Failed");
    }
}

export default fork(function*() {
    yield takeLatest(
        MPA_DPA_ACTIONS.FETCH_BUSINESS_PROGRAM_LIST,
        getBusinessProgramList
    );
    yield takeLatest(
        MPA_DPA_ACTIONS.FETCH_BUSINESS_PROGRAM_DETAIL,
        getBusinessProgramDetails
    );
    yield takeLatest(
        MPA_DPA_ACTIONS.FETCH_COMPANY_BUSINESS_PROGRAM_DETAIL,
        getCompanyBusinessProgramDetails
    );
    yield takeLatest(
        MPA_DPA_ACTIONS.CREATE_BUSINESS_PROGRAM_DETAIL,
        createBusinessProgram
    );
    yield takeLatest(
        MPA_DPA_ACTIONS.CREATE_BUSINESS_INTEREST_DETAIL,
        createBusinessProgramInterest
    );
    yield takeLatest(
        MPA_DPA_ACTIONS.CREATE_BUSINESS_QUALIFICATION_DETAIL,
        createBuyerQualificationDetails
    );
    yield takeLatest(
        MPA_DPA_ACTIONS.CREATE_BUSINESS_FEE_DETAIL,
        createBusinessProgramFee
    );
    yield takeLatest(
        MPA_DPA_ACTIONS.CREATE_BUSINESS_FACILITY_DETAIL,
        createBusinessProgramFacilityDetails
    );
    yield takeLatest(
        MPA_DPA_ACTIONS.CREATE_BUSINESS_RECOURSE_DETAIL,
        createBusinessProgramRecourseDetails
    );
    yield takeLatest(
        MPA_DPA_ACTIONS.CREATE_BUSINESS_CASHBACK_DETAIL,
        createBusinessProgramCashBack
    );
    yield takeLatest(
        MPA_DPA_ACTIONS.CREATE_BUSINESS_ATTACHMENT_DETAIL,
        createBusinessAttachments
    );
    yield takeLatest(
        MPA_DPA_ACTIONS.CREATE_BUSINESS_PROGRAM_BASIC_DETAIL,
        createBasicDetails
    );
    yield takeLatest(
        MPA_DPA_ACTIONS.CREATE_BUSINESS_AGREEMENT_DETAIL,
        createBusinessAgreementDetails
    );

    yield takeLatest(
        MPA_DPA_ACTIONS.UPDATE_BUSINESS_PROGRAM_DETAIL,
        updateBusinessProgram
    );
    yield takeLatest(
        MPA_DPA_ACTIONS.UPDATE_BUSINESS_INTEREST_DETAIL,
        updateBusinessProgramInterest
    );
    yield takeLatest(
        MPA_DPA_ACTIONS.UPDATE_BUSINESS_QUALIFICATION_DETAIL,
        updateBuyerQualificationDetails
    );
    yield takeLatest(
        MPA_DPA_ACTIONS.UPDATE_BUSINESS_FEE_DETAIL,
        updateBusinessProgramFee
    );
    yield takeLatest(
        MPA_DPA_ACTIONS.UPDATE_BUSINESS_FACILITY_DETAIL,
        updateBusinessProgramFacilityDetails
    );
    yield takeLatest(
        MPA_DPA_ACTIONS.UPDATE_BUSINESS_RECOURSE_DETAIL,
        updateBusinessProgramRecourseDetails
    );
    yield takeLatest(
        MPA_DPA_ACTIONS.UPDATE_BUSINESS_CASHBACK_DETAIL,
        updateBusinessProgramCashBack
    );
    yield takeLatest(
        MPA_DPA_ACTIONS.UPDATE_BUSINESS_ATTACHMENT_DETAIL,
        updateBusinessAttachments
    );
    yield takeLatest(
        MPA_DPA_ACTIONS.UPDATE_BUSINESS_PROGRAM_BASIC_DETAIL,
        updateBasicDetails
    );
    yield takeLatest(
        MPA_DPA_ACTIONS.UPDATE_BUSINESS_AGREEMENT_DETAIL,
        updateBusinessAgreementDetails
    );

});